import * as React                         from "react";
import Tabs                               from "@material-ui/core/Tabs";
import Tab                                from "@material-ui/core/Tab";
import {
    Checkbox,
    FormControlLabel,
    TextField,
}                                         from "@material-ui/core";
import { Row, Col }                       from "reactstrap";
import SimpleReactValidator               from "simple-react-validator";
import { TabPanel }                       from "../../../Components/TabPanel/TabPanel";
import { GroupButtons }                   from "../../../Components/GroupButtons/GroupButtons";
import GalleryImagesViewModel
                                          from "../../../../ViewModel/Gallery/CreateOrEdit/GalleryImagesViewModel";
import { withNamespaces, WithNamespaces } from "react-i18next";
import { observer }                       from "mobx-react";
import { Tutorial }                       from "../../../../Models/Tutorial/Tutorial";
import WysiwygViewModel                   from "../../../../ViewModel/WYSIWYG/WysiwygViewModel";
import CreateUpdatePageSeo                from "../../../Components/PageSeo/CreateUpdatePageSeo";


interface INewEditGalleryViewProps extends WithNamespaces {
    currentTab: number;
    setCurrentTab: (tab: number) => void;
    currentTabSeo: number;
    setCurrentTabSeo: (tab: number) => void;
    tutorial: Tutorial;
    validate: () => boolean;
    spinner: boolean;
    save: () => void;
    cancel: () => void;
    validator: SimpleReactValidator;
}

@observer
class CreateOrEditTutorialView extends React.Component<INewEditGalleryViewProps, {}> {
    public render(): React.ReactNode {
        const {
                  currentTab,
                  setCurrentTab,
                  currentTabSeo,
                  setCurrentTabSeo,
                  tutorial,
                  spinner,
                  cancel,
                  validate,
                  save,
                  validator,
                  t
              }       = this.props,
              gallery = tutorial.getGallery();


        return (
            <div className={``}>
                <form noValidate autoComplete="off">
                    <Tabs
                        value={currentTab}
                        onChange={(event: React.ChangeEvent<{}>, newValue: number) => {
                            setCurrentTab(newValue);
                        }} aria-label="tabs"
                    >
                        <Tab label={t("edit.general")}/>
                        <Tab label={t("edit.images")}/>
                        <Tab label={t("SEO")}/>
                    </Tabs>
                    <hr/>
                    <TabPanel value={currentTab} index={0}>
                        <Row>
                            <Col xs={12} md={6} xl={6}>
                                <TextField
                                    fullWidth
                                    label={t("edit.name")}
                                    className={""}
                                    value={tutorial.getName() || ""}
                                    onChange={(evt: React.ChangeEvent<HTMLInputElement>) => {
                                        tutorial.setName(evt.currentTarget.value);
                                        gallery.setName(evt.currentTarget.value);
                                    }}
                                    margin="normal"
                                />
                                {validator.message(t("edit.name"), tutorial.getName(), "required")}
                            </Col>
                            <Col xs={12} md={6} xl={6}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={tutorial.getActive()}
                                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                tutorial.setActive(event.currentTarget.checked);
                                            }}
                                            value={tutorial.getActive()}
                                            color="primary"
                                        />
                                    }
                                    label={t("edit.active")}
                                />
                            </Col>
                            <Col xs={12} md={6} xl={6}>
                                <TextField
                                    fullWidth
                                    label={t("edit.youTubeId")}
                                    className={""}
                                    value={tutorial.getYoutubeId() || ""}
                                    onChange={(evt: React.ChangeEvent<HTMLInputElement>) => {
                                        tutorial.setYoutubeId(evt.currentTarget.value);
                                    }}
                                    margin="normal"
                                />
                                {validator.message(t("edit.youTubeId"), tutorial.getYoutubeId(), "required")}
                            </Col>
                            <Col xs={12} md={6} xl={4}>
                                <TextField
                                    fullWidth
                                    label={t("edit.shortDescription")}
                                    className={""}
                                    value={tutorial.getShortDescription() || ""}
                                    multiline
                                    rowsMax="4"
                                    rows="4"
                                    onChange={(evt: React.ChangeEvent<HTMLInputElement>) => {
                                        tutorial.setShortDescription(evt.currentTarget.value);
                                    }}
                                    margin="normal"
                                />
                                {validator.message(t("edit.shortDescription"), tutorial.getShortDescription(), "required")}
                            </Col>
                            <Col xs={12} md={12} xl={12}>
                                <WysiwygViewModel
                                    onChange={(item: string) => tutorial.setDescription(item)}
                                    value={tutorial.getDescription()}
                                />
                                {validator.message(t("edit.description"), tutorial.getDescription(), "required")}
                            </Col>
                        </Row>
                    </TabPanel>
                    <TabPanel value={currentTab} index={1}>
                        <GalleryImagesViewModel
                            gallery={gallery}
                            validator={validator}
                        />
                    </TabPanel>
                    <TabPanel value={currentTab} index={2}>
                        <CreateUpdatePageSeo
                            currentTab={currentTabSeo}
                            setCurrentTab={setCurrentTabSeo}
                            validator={validator}
                            seoData={tutorial.getSeoData()}
                        />
                    </TabPanel>
                    <hr/>
                    <GroupButtons
                        action={save}
                        spinner={spinner}
                        validate={validate}
                        cancel={cancel}
                    />
                </form>
            </div>
        );
    }
}

export default withNamespaces("page")(CreateOrEditTutorialView);
